export default [
  {
    name: 'Addis Ababa',
    country: 'Ethiopia',
    countryCode: 'ET',
    region: 'Addis Ababa',
    latitude: 9.027222222,
    longitude: 38.736944444,
    population: 5006000,
    distance: 0,
  },
  {
    name: 'Mexico City',
    country: 'Mexico',
    countryCode: 'MX',
    region: 'Mexico City',
    latitude: 19.443055555,
    longitude: -99.144722222,
    population: 9209944,
    distance: 1.04,
  },
  {
    name: 'New York',
    country: 'United States of America',
    countryCode: 'US',
    region: 'New York',
    latitude: 42.63,
    longitude: -75.04,
    population: 8550405,
    distance: 0,
  },
  {
    name: 'Tokyo',
    country: 'Japan',
    countryCode: 'JP',
    region: 'Tokyo',
    latitude: 35.658055555,
    longitude: 139.751388888,
    population: 37274000,
    distance: 0,
  },
  {
    name: 'London',
    country: 'United Kingdom',
    countryCode: 'GB',
    region: 'England',
    latitude: 51.507222222,
    longitude: -0.1275,
    population: 9002488,
    distance: 0,
  },
  {
    name: 'Beijing',
    country: "People's Republic of China",
    countryCode: 'CN',
    region: 'Beijing',
    latitude: 39.91,
    longitude: 116.36,
    population: 21333000,
    distance: 0,
  },
  {
    name: 'Paris',
    country: 'France',
    countryCode: 'FR',
    region: 'Île-de-France',
    latitude: 48.862777777,
    longitude: 2.344444444,
    population: 2165423,
    distance: 0,
  },
  {
    name: 'Amsterdam',
    country: 'Netherlands',
    countryCode: 'NL',
    region: 'North Holland',
    latitude: 52.37348,
    longitude: 4.89806,
    population: 1166000,
    distance: 0,
  },
  {
    name: 'Madrid',
    country: 'Spain',
    countryCode: 'ES',
    region: 'Community of Madrid',
    latitude: 40.40225,
    longitude: -3.71029,
    population: 6714000,
    distance: 0,
  },
  {
    name: 'Dubai',
    country: 'United Arab Emirates',
    countryCode: 'AE',
    region: 'Dubai',
    latitude: 25.266666666,
    longitude: 55.316666666,
    population: 2964000,
    distance: 0,
  },
];
